import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityService } from 'src/app/services/activity.service';

@Component({
  selector: 'app-savebpmn',
  templateUrl: './savebpmn.component.html',
  styleUrls: ['./savebpmn.component.css']
})
export class SavebpmnComponent implements OnInit {
  
  @Input() xml: any;
  @Input() types: Array<any>;
  procces: any = {};
  token: string;
  proc: boolean
  type: any;
  viewTable: boolean = false;
  deadlines: Array<any>;
  
  // swhowTypes: boolean = false;

  constructor(
    private modalService: NgbModal,
    private globals: GlobalService,
    public activeModal: NgbActiveModal,
    public activityService: ActivityService
  ) { }
    
  ngOnInit() {
    this.token = this.globals.getToken();
    console.log("XML: ", this.xml);
    this.procces.withTypes = false;
    this.procces.before = 20;
  }

  newProcces(){
    if (this.procces.procces_name) {
      this.proc = true;
      document.getElementById("nameProcess").innerHTML = "";
    } else {
      this.proc = false;
      document.getElementById("nameProcess").innerHTML = "↓ Il campo è obbligatorio";
    }
    this.procces.bpmn = this.xml;
    if(this.type){
      this.procces.type_id = this.type.type_id;
    }
    this.activityService.newProcces(this.token, {procces: this.procces}).subscribe((res) => {
      console.log("OK: ", res);
      this.close();
    },
    (err) => {
      console.error("Errore: ", err);
      
    })
    console.log("Invierò: ", this.procces); 
  }

  showDeadlines(type){
    this.activityService.getTypeDeadline(this.token, type.type_id).subscribe(
      res => {
        console.log("Risposta: ", res);
        this.deadlines = res ? res : [];
        this.deadlines.forEach((deadl) => {
          deadl.start_date = this.globals.cleanDateAndHour(deadl.start_date);
          deadl.end_date = this.globals.cleanDateAndHour(deadl.end_date);
        })
        this.viewTable = true;
      },
      err => {
        console.error("Errore: ", err);
        
      }
    )
  }

  canceling() {
    this.activeModal.close('cancel');
  }

  close() {
    this.activeModal.close();
  }
  
}
  